import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools.js'

import RestrictionAlert from '@/components//UI/restrictionAlert/restrictionAlert.vue'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'

import NewLeadForm from './newlead-form.js'
import NewLeadData from '@/shared/models/crm/newLeadmodel.js'

export default {
  name: 'ModalNewLead',
  mixins: [ActionsForm],
  props: {
    board: {
      type: Object,
      default: null
    },
    boardColumns: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      personDocument: null,
      personId: null,
      alreadyPerson: false,
      filledDocument: false,
      data: NewLeadData,
      form: NewLeadForm,
      nameNotPerson: '',
      buttonDisabled: false,
      searchingByName: false
    }
  },
  components: {
    RestrictionAlert
  },
  mounted () {
    this.onGetAllOrigin()
  },
  computed: {
    boardColumnId () {
      let result = null
      if (this.boardColumns && this.boardColumns.length > 0) {
        let boardColumn = this.boardColumns.find(x => x.posicao === 0)
        if (boardColumn) {
          result = boardColumn.id
        }
      }
      return result
    }
  },
  methods: {
    onLoad () {},
    showModal () {
      this.onClear()
      this.clearForms()
      this.onLoadBoards()
      this.$refs['modal-newlead'].show()
    },
    hideModal () {
      this.$refs['modal-newlead'].hide()
    },
    async onCreate () {
      this.buttonDisabled = true
      if (this.alreadyPerson) {
        await CardRepository.Create(this.createDataAlreadyPerson())
          .then((response) => {
            this.hideModal()
            toast.success(this.$lang.Common.Alerts.Success, 'Nova Oportunidade')
            this.$emit('Back')
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        await CardRepository.CreateCardAndPerson(this.createDataNotAlreadyPerson())
          .then((response) => {
            this.hideModal()
            toast.success(this.$lang.Common.Alerts.Success, 'Nova Oportunidade')
            this.$emit('Back')
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    createDataAlreadyPerson () {
      return {
        ...this.createData(),
        'pessoaId': this.personId
      }
    },
    createDataNotAlreadyPerson () {
      return {
        ...this.createData(),
        'pessoa': {
          'nome': this.form.name.selected ? this.form.name.selected.value : this.form.name.value,
          'email': this.form.email.value,
          'document': this.form.documento.value.toString().replace(/[^\d]+/g, ''),
          'Telefone': [
            {
              'telefone': this.form.telefone.value,
              'tipoContato': 'COMERCIAL'
            },
            {
              'telefone': this.form.celular.value,
              'tipoContato': 'CELULAR'
            }
          ]
        }
      }
    },
    createData () {
      let cardData = {
        'boardColumnId': this.form.colunaCobranca.value,
        'motivoPerdaId': null,
        'posicao': 0,
        'situacao': 'ATIVO',
        'countReativado': 0,
        'dataCriacao': new Date().toISOString(),
        'dataInicioSituacao': new Date().toISOString(),
        'dataReativacao': null,
        'origemLeadId': this.form.leadOriginID.value
      }
      return cardData
    },
    manageNameComponent (search) {
      if (search !== '') {
        this.nameNotPerson = search
        return
      }

      if (!this.form.name.selected) {
        this.filledDocument = true
        this.form.name.value = this.nameNotPerson
        toast.info('Não foi encontrado uma pessoa com este Nome.', 'Nova Oportunidade')
        this.$refs.documento.focus()
      }
    },
    onLoadLeads (search) {
      this.manageNameComponent(search)
      if (this.form.name.selected && !search) {
        this.form.name.value = this.form.name.selected.text

        this.searchingByName = true
        this.onSearchPessoa(search.value)
        this.searchingByName = false
      } else if (typeof (search) === 'string') {
        PersonRepository.GetByName(search)
          .then((response) => {
            this.form.name.listOptions = response.data.content.filter((x) => x.id != null).map((x) => ({'value': x.document, 'text': x.nome}))
          })
      }
    },
    getPersonData (documentOnlyNumber) {
      PersonRepository.GetByDocument(documentOnlyNumber)
        .then((response) => {
          let data = response.data.content

          if (data.length > 0) {
            let personId = data[0].id
            this.alreadyPerson = true
            this.personId = personId
            this.$nextTick(async () => {
              await this.setFormValues(response.data.content[0])
              this.$forceUpdate()
            })
          } else {
            this.alreadyPerson = false
            if (!this.form.name.value) {
              toast.info('Não foi encontrado uma pessoa com este CPF.', 'Nova Oportunidade')
            }
          }
        })
        .catch((err) => {
          console.log('err', err)
          this.onException(err)
        })
    },
    onSearchPessoa (document) {
      if (this.form.documento.value || this.form.name.selected) {
        if (this.form.documento.value) this.filledDocument = true
        this.personDocument = this.searchingByName ? this.form.name.selected.value : this.form.documento.value.replace(/[^\d]+/g, '')

        if (this.form.documento.value && this.form.name.value) return

        this.getPersonData(this.personDocument)
      } else {
        this.clearForms()
        toast.info('Atenção! Você precisa informar um CPF ou CNPJ para localizar o contato.', 'Nova Oportunidade')
      }
    },
    clearForms () {
      this.filledDocument = false
      this.form.documento.value = null
      this.form.name.value = null
      this.form.name.selected = null
      this.form.name.listOptions = []
      this.form.email.value = ''
      this.form.celular.value = ''
      this.form.telefone.value = ''
      this.form.leadOriginID.value = null
      this.dismissCountDown = 0
      this.personDocument = null
      this.form.boardCobranca.value = null
      this.form.colunaCobranca.value = null
    },
    setFormValues (dataToForm) {
      this.form.documento.value = dataToForm.document
      this.form.name.selected = dataToForm.nome
      this.form.name.value = dataToForm.nome
      this.form.email.value = dataToForm.email
      for (let i in dataToForm.telefone) {
        if (dataToForm.telefone[i].tipoContato === 'CELULAR') {
          this.form.celular.value = dataToForm.telefone[i].telefone
        } else {
          this.form.telefone.value = dataToForm.telefone[i].telefone
        }
      }
    },
    onGetAllOrigin () {
      OriginRepository.GetAll()
        .then((response) => {
          let result = response.data.content
          let filteredResult = []
          // CHECK IF ORIGEM DOES NOT HAVE SPECIFIC TYPES || SPECIFIC TYPE MACHES THE BOARD
          result.forEach(el => {
            if (!el.tipoAcessoOrigem.length || this.hasBoardType(el.tipoAcessoOrigem)) {
              filteredResult.push(el)
            }
          })
          this.form.leadOriginID.options = filteredResult.map((x) => ({'value': x.id, 'text': x.nome}))
        })
        .catch(this.onException)
    },
    onLoadBoards () {
      BoardRepository.GetAllTipoBoard('COBRANCA')
        .then((res) => {
          let options = res.data.content
            .filter((x) => x.id != null && x.arquivado !== true)
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.form.boardCobranca.options = options
        })
        .catch(this.onException)
    },
    onLoadColumns (boardId) {
      if (boardId) {
        BoardColumnRepository.SearchActive(boardId)
          .then((res) => {
            this.form.colunaCobranca.options = res.data.content.filter((x) => x.id != null).map((x) => {
              return x.eventoColuna === 1 ? ({'value': x.id, 'text': x.nome, disabled: true}) : ({'value': x.id, 'text': x.nome})
            })
          })
          .catch(this.onException)
      } else {
        this.form.colunaCobranca.options = []
      }
    },
    hasBoardType (originArray) {
      let boardType = 'COBRANCA'
      return originArray.some((board) => board === boardType)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/cobranca/modal/new/newlead.js